(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-cns-collection-grid"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-editorial-body"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('s24-editorial-body')) {
    class Size24EditorialBody extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this._s24Mounted) this.mount();
        });
      }
      schoolDestination(value) {
        if (!value || !value.trim() || value.trim().startsWith('#')) return null;
        try {
          const url = new URL(value, window.location.href);
          return ['http:', 'https:'].includes(url.protocol) ? url : null;
        } catch (_) { return null; }
      }
      mount() {
        this._s24Mounted = true;
        this._s24Abort = new AbortController();
        const signal = this._s24Abort.signal;
        this.querySelectorAll('[data-s24-school]').forEach((panel) => {
          const picker = panel.querySelector('[data-s24-school-picker]');
          const select = panel.querySelector('[data-s24-school-select]');
          const button = panel.querySelector('[data-s24-school-go]');
          const fallback = panel.querySelector('[data-s24-school-fallback]');
          const status = panel.querySelector('[data-s24-school-status]');
          if (!picker || !select || !button) return;
          Array.from(select.options).forEach((option) => {
            if (option.value && !this.schoolDestination(option.value)) {
              option.disabled = true;
              option.hidden = true;
            }
          });
          const hasDestination = Array.from(select.options).some((option) => this.schoolDestination(option.value));
          if (!hasDestination) return;
          picker.hidden = false;
          if (fallback) fallback.hidden = true;
          const update = () => {
            button.disabled = !this.schoolDestination(select.value);
            if (status) status.textContent = '';
          };
          select.addEventListener('change', update, { signal });
          button.addEventListener('click', () => {
            const destination = this.schoolDestination(select.value);
            if (!destination) {
              button.disabled = true;
              if (status) status.textContent = 'Please select a school.';
              select.focus();
              return;
            }
            this.navigateToSchool(destination);
          }, { signal });
          update();
        });
      }
      navigateToSchool(destination) {
        window.location.assign(destination.href);
      }
      disconnectedCallback() {
        this._s24Abort?.abort();
        this._s24Mounted = false;
      }
    }
    customElements.define('s24-editorial-body', Size24EditorialBody);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-polo-model-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('s24-polo-model-gallery')) {
  class Size24PoloModelGallery extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.modelFit = this.modelFit || 'men';
      this.panel = this.querySelector('.s24mg');
      if (!this.panel) return;
      this.lastKey = '';
      try { this.map = JSON.parse(this.querySelector('[data-model-map]').textContent); } catch (_) { return; }
      this.prepareRange();
      this.clickHandler = event => {
        const colourButton = event.target.closest('[data-model-colour]');
        if (colourButton && this.panel.contains(colourButton) && this.root) {
          const key = colourButton.dataset.modelColour;
          const swatch = [...this.root.querySelectorAll('[data-colours] [data-colour]')].find(b => b.dataset.colour === key && !b.hidden && !b.matches(':disabled'));
          if (swatch) swatch.click();
          return;
        }
        const button = event.target.closest('[data-model-fit]');
        if (!button || !this.panel.contains(button)) return;
        this.modelFit = button.dataset.modelFit;
        this.panel.querySelectorAll('[data-model-fit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.sync();
      };
      this.panel.addEventListener('click', this.clickHandler);
      this.unloadHandler = event => {
        if (event.detail && String(event.detail.sectionId) === this.dataset.owner) this.remove();
      };
      document.addEventListener('shopify:section:unload', this.unloadHandler);
      this.discovery = new MutationObserver(() => {
        if (!this.isConnected) return;
        if (this.root && this.root.isConnected && this.panel.isConnected) return;
        this.mount();
      });
      this.discovery.observe(document.documentElement, {childList: true, subtree: true});
      this.mount();
    }
    prepareRange() {
      const fit = new URL(window.location.href).searchParams.get('s24range');
      if (fit !== 'men' && fit !== 'women') return;
      const browse = [...document.querySelectorAll('[data-s24-browse]')].find(node => node.dataset.s24Browse === this.dataset.owner);
      if (!browse) return;
      browse.dataset.range = fit;
      browse.querySelectorAll('[data-browse-fit]').forEach(figure => { figure.hidden = figure.dataset.browseFit !== fit; });
      const heading = browse.querySelector('[data-browse-heading]');
      if (heading) heading.textContent = this.dataset.code + ' · ' + (fit === 'women' ? 'Women’s' : 'Men’s') + ' colour range' + (this.dataset.code === 'RS01' ? ' · Unisex polo' : '');
      browse.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin || url.searchParams.get('s24customise') !== '1') return;
        url.searchParams.set('s24range', fit);
        if (link.hasAttribute('data-browse-customise')) url.searchParams.set('s24fit', fit);
        link.href = url.pathname + url.search + url.hash;
      });
      const back = this.panel.querySelector('[data-browse-return]');
      if (back) {
        const url = new URL(back.href, window.location.origin);
        url.searchParams.set('s24range', fit);
        back.href = url.pathname + url.search;
      }
    }
    mount() {
      const sport = this.dataset.code === 'RS01';
      const roots = document.querySelectorAll(sport ? '.s24d2cartorder' : '.s24dtcartorder');
      if (roots.length !== 1) { if (this.panel) this.panel.hidden = true; return; }
      const root = roots[0];
      const target = root.querySelector(sport ? '.s24ru-colour-size-group' : '.s24dt-colour-size-group');
      if (!target) return;
      const occupied = target.querySelector('.s24mg');
      if (occupied && occupied !== this.panel) return;
      if (target.contains(this.panel) && this.root === root) return;
      this.releaseRoot();
      this.root = root;
      target.appendChild(this.panel);
      this.panel.hidden = false;
      this.lastKey = '';
      this.generation = (this.generation || 0) + 1;
      this.headingNode = root.querySelector('.s24d-product-header [data-title]');
      this.originalTitle = this.headingNode && this.headingNode.textContent;
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.panel.contains(record.target))) this.sync();
      });
      this.observer.observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed', 'hidden', 'disabled']});
      this.sync();
      this.prepareBrowse();
    }
    prepareBrowse() {
      this.browse = [...document.querySelectorAll('[data-s24-browse]')].find(node => node.dataset.s24Browse === this.dataset.owner);
      if (!this.browse || !this.root) return;
      const root = this.root;
      const routeGeneration = this.generation;
      const params = new URL(window.location.href).searchParams;
      const customise = params.get('s24customise') === '1';
      this.savedHidden = root.hidden;
      if (!customise) {
        if (!window.Shopify?.designMode) root.hidden = true;
        this.browse.hidden = false;
        return;
      }
      const requestedColour = params.get('s24colour');
      const fit = params.get('s24fit') === 'women' ? 'women' : 'men';
      const valid = this.map.some(row => row.code === this.dataset.code && row.colour === requestedColour && row.fit === fit && row.side === 'front');
      if (!valid) return;
      const activate = () => {
        if (!this.isConnected || this.root !== root || this.generation !== routeGeneration) return;
        if (this.dataset.code === 'DT01') {
          const fitButton = root.querySelector('[data-fits] [data-fit="' + (fit === 'women' ? 'womens' : 'mens') + '"]');
          if (!fitButton || fitButton.matches(':disabled')) return;
          fitButton.click();
        } else {
          this.modelFit = fit;
          this.panel.querySelectorAll('[data-model-fit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modelFit === fit)));
        }
        requestAnimationFrame(() => {
          if (!this.isConnected || this.root !== root || this.generation !== routeGeneration) return;
          if (this.dataset.code === 'DT01') {
            const activeFit = root.querySelector('[data-fits] [data-fit][aria-pressed="true"]');
            if (!activeFit || activeFit.dataset.fit !== (fit === 'women' ? 'womens' : 'mens')) return;
          }
          const nativeKey = this.dataset.code === 'DT01' ? (fit === 'women' ? 'Women’s · ' : 'Men’s · ') + requestedColour : requestedColour;
          const button = [...root.querySelectorAll('[data-colours] [data-colour]')].find(node => node.dataset.colour === nativeKey && !node.hidden && !node.matches(':disabled'));
          if (!button) return;
          button.click();
          requestAnimationFrame(() => {
            if (!this.isConnected || this.root !== root || this.generation !== routeGeneration || button.getAttribute('aria-pressed') !== 'true') return;
            this.browse.hidden = true;
            root.hidden = false;
            this.sync();
            root.scrollIntoView({block: 'start'});
          });
        });
      };
      this.loadHandler = activate;
      if (document.readyState === 'complete') activate();
      else window.addEventListener('load', activate, {once: true});
    }
    sync() {
      if (!this.root) return;
      if (this.headingNode && this.headingNode.textContent !== this.dataset.code) { this.originalTitle = this.headingNode.textContent; this.headingNode.textContent = this.dataset.code; }
      const swatch = this.root.querySelector('[data-colours] [data-colour][aria-pressed="true"]');
      const sideButton = this.root.querySelector('.s24d-view-tabs [data-view][aria-pressed="true"]');
      const side = sideButton && sideButton.dataset.view;
      let colour = swatch && swatch.dataset.colour;
      let fit = this.modelFit;
      if (this.dataset.code === 'DT01') {
        const fitButton = this.root.querySelector('[data-fits] [data-fit][aria-pressed="true"]');
        fit = fitButton && fitButton.dataset.fit === 'womens' ? 'women' : 'men';
        const prefix = fit === 'women' ? 'Women’s · ' : 'Men’s · ';
        colour = colour && colour.startsWith(prefix) ? colour.slice(prefix.length) : null;
      }
      const nativeState = [...this.root.querySelectorAll('[data-colours] [data-colour]')].map(b => [b.dataset.colour, b.hidden, b.matches(':disabled')]);
      const key = JSON.stringify([this.dataset.code, colour, fit, side, nativeState]);
      if (key === this.lastKey) return;
      this.lastKey = key;
      const grid = this.panel.querySelector('[data-model-colours]');
      const focusedColour = grid.contains(document.activeElement) ? document.activeElement.closest('[data-model-colour]')?.dataset.modelColour : null;
      grid.replaceChildren();
      const swatches = [...this.root.querySelectorAll('[data-colours] [data-colour]')].filter(b => !b.hidden);
      for (const swatchButton of swatches) {
        const nativeKey = swatchButton.dataset.colour;
        const name = this.dataset.code === 'DT01' ? nativeKey.split(' · ').slice(1).join(' · ') : nativeKey;
        const entry = this.map.find(row => row.code === this.dataset.code && row.colour === name && row.fit === fit && row.side === side);
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.modelColour = nativeKey;
        button.setAttribute('aria-pressed', String(nativeKey === (swatch && swatch.dataset.colour)));
        button.disabled = swatchButton.matches(':disabled');
        if (entry && entry.url) {
          const thumb = document.createElement('img');
          thumb.src = entry.url; thumb.alt = ''; thumb.loading = 'lazy'; thumb.width = 90; thumb.height = 112;
          thumb.onerror = () => { thumb.hidden = true; };
          button.appendChild(thumb);
        }
        const label = document.createElement('span'); label.textContent = name; button.appendChild(label); grid.appendChild(button);
      }
      if (focusedColour) { const replacement = [...grid.querySelectorAll('[data-model-colour]')].find(b => b.dataset.modelColour === focusedColour && !b.disabled); if (replacement) replacement.focus({preventScroll: true}); }
      const photo = this.panel.querySelector('[data-model-photo]');
      const missing = this.panel.querySelector('[data-model-missing]');
      const caption = this.panel.querySelector('[data-model-caption]');
      const label = this.dataset.code + ' · ' + (colour || 'Select colour') + ' · ' + (fit === 'women' ? 'Women' : 'Men') + ' · ' + (side === 'back' ? 'Back' : 'Front');
      caption.textContent = label;
      photo.hidden = true;
      photo.removeAttribute('src');
      photo.alt = label + ' model photograph';
      missing.hidden = false;
      missing.textContent = 'Model photo unavailable for this exact colour, fit and side.';
      const match = this.map.find(row => row.code === this.dataset.code && row.colour === colour && row.fit === fit && row.side === side);
      if (!match || !match.url) return;
      const preload = new Image();
      const generation = this.generation;
      preload.onload = () => { if (this.lastKey === key && generation === this.generation && this.isConnected && this.panel.isConnected) { photo.src = match.url; photo.hidden = false; missing.hidden = true; } };
      preload.onerror = () => { if (this.lastKey === key && generation === this.generation && this.isConnected) { photo.hidden = true; missing.hidden = false; } };
      preload.src = match.url;
    }
    releaseRoot() {
      if (this.loadHandler) window.removeEventListener('load', this.loadHandler);
      if (this.root && this.savedHidden !== undefined) this.root.hidden = this.savedHidden;
      this.savedHidden = undefined;
      if (this.browse) this.browse.hidden = false;
      if (this.observer) this.observer.disconnect();
      if (this.headingNode && this.headingNode.isConnected && this.headingNode.textContent === this.dataset.code) this.headingNode.textContent = this.originalTitle;
      this.root = null;
      this.headingNode = null;
    }
    disconnectedCallback() {
      if (this.discovery) this.discovery.disconnect();
      this.releaseRoot();
      if (this.panel) {
        this.panel.removeEventListener('click', this.clickHandler);
        this.panel.hidden = true;
        this.appendChild(this.panel);
      }
      document.removeEventListener('shopify:section:unload', this.unloadHandler);
      this.generation = (this.generation || 0) + 1;
      this.started = false;
    }
  }
  customElements.define('s24-polo-model-gallery', Size24PoloModelGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-royal-homepage"]) return;
  try {
    
if (!customElements.get('size24-royal-homepage')) {
  customElements.define('size24-royal-homepage', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.messages = JSON.parse(this.querySelector('[data-home-messages]').textContent);
      this.carousel = this.querySelector('[data-carousel]');
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.visuals = [...this.querySelectorAll('[data-visual]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.pause = this.querySelector('[data-pause]');
      this.index = Number.isInteger(this.index) ? this.index % this.panels.length : 0;
      this.userPaused = Boolean(this.userPaused);
      this.hovered = false; this.focused = this.contains(document.activeElement); this.inView = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-carousel-controls]').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.pause.addEventListener('click', () => { this.userPaused = !this.userPaused; this.schedule(); }, options);
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.show(index, true), options);
        dot.addEventListener('keydown', event => {
          const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.panels.length - 1 };
          if (!(event.key in keys)) return;
          event.preventDefault(); this.show(keys[event.key], true); this.dots[this.index].focus();
        }, options);
      });
      this.carousel.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); } }, options);
      this.carousel.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      const visuals = this.querySelector('[data-visuals]');
      visuals.addEventListener('pointerdown', event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.drag = { x: event.clientX, y: event.clientY, id: event.pointerId }; this.schedule();
      }, options);
      document.addEventListener('pointerup', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        this.drag = null; this.schedule();
        const x = event.clientX - drag.x, y = event.clientY - drag.y;
        if (Math.abs(x) < 60 || Math.abs(x) < Math.abs(y) * 1.25) return;
        this.suppressClickUntil = Date.now() + 500;
        this.show(this.index + (x < 0 ? 1 : -1), true);
      }, options);
      document.addEventListener('pointercancel', event => { if (this.drag?.id === event.pointerId) { this.drag = null; this.schedule(); } }, options);
      visuals.addEventListener('dragstart', event => event.preventDefault(), options);
      visuals.addEventListener('click', event => {
        if (Date.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); }
      }, { ...options, capture: true });
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting); this.schedule();
        });
        this.visibilityObserver.observe(this.carousel);
      }
      this.input = this.querySelector('[data-school-query]');
      this.results = this.querySelector('[data-school-results]');
      this.schoolLinks = [...this.results.querySelectorAll('[data-school-link]')];
      this.schoolStatus = this.querySelector('[data-school-status]');
      this.input.addEventListener('input', () => this.search(false), options);
      this.querySelector('[data-school-form]').addEventListener('submit', event => {
        event.preventDefault(); this.search(true);
        this.schoolLinks.find(link => !link.hidden)?.focus();
      }, options);
      this.querySelector('[data-school-clear]').hidden = false;
      this.querySelector('[data-school-clear]').addEventListener('click', () => {
        this.input.value = ''; this.search(false); this.input.focus();
      }, options);
      this.querySelector('[data-finder]').addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.results.hidden = true; this.input.focus(); }
      }, options);
      this.results.hidden = true;
      this.show(this.index, false);
      if (this.input.value.trim()) this.search(false);
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.timer = null;
      this.visibilityObserver?.disconnect();
      this.controller?.abort(); this.controller = null; this.drag = null;
    }
    show(index, manual) {
      this.index = (index + this.panels.length) % this.panels.length;
      this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
      this.visuals.forEach((visual, i) => { visual.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      if (manual) this.querySelector('[data-slide-status]').textContent = this.panels[this.index].getAttribute('aria-label');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer); this.timer = null;
      this.pause.disabled = this.motion.matches;
      this.pause.textContent = this.motion.matches ? this.messages.motion_off : this.userPaused ? this.messages.play : this.messages.pause;
      this.pause.setAttribute('aria-pressed', String(this.userPaused || this.motion.matches));
      if (!this.controller || this.userPaused || this.motion.matches || this.hovered || this.focused || document.hidden || !this.inView || this.drag) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), 7000);
    }
    normalize(value) {
      return String(value || '').normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace(/[’']/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    }
    search(force) {
      const tokens = this.normalize(this.input.value).split(/\s+/).filter(Boolean);
      let count = 0;
      for (const link of this.schoolLinks) {
        const haystack = this.normalize(link.dataset.search).replace(/\s/g, '');
        const matches = tokens.every(token => haystack.includes(token));
        link.hidden = !matches; if (matches) count++;
      }
      this.results.hidden = !force && !tokens.length;
      this.querySelector('[data-school-empty]').hidden = count !== 0;
      this.schoolStatus.textContent = this.results.hidden ? '' : this.messages.results.replace('__COUNT__', String(count));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-school-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('size24-school-directory')) {
  customElements.define('size24-school-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = Array.from(this.querySelectorAll('[data-school]'));
      this.input = this.querySelector('[data-query]');
      this.grid = this.querySelector('[data-grid]');
      this.suggestions = this.querySelector('[data-suggestions]');
      this.suggestionList = this.querySelector('[data-suggestion-list]');
      this.suggestionsDismissed = false;
      this.sortButton = this.querySelector('[data-sort]');
      this.querySelector('[data-finder]').hidden = false;
      this.querySelector('[data-finder]').addEventListener('submit', event => { event.preventDefault(); this.updateResults(); }, options);
      this.input.addEventListener('input', () => { this.suggestionsDismissed = false; this.updateResults(); }, options);
      this.input.addEventListener('focus', () => { this.suggestionsDismissed = false; this.updateResults(); }, options);
      this.querySelector('[data-finder]').addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.suggestions.hidden) {
          event.preventDefault();
          this.input.focus();
          this.suggestionsDismissed = true;
          this.suggestions.hidden = true;
        }
      }, options);
      this.querySelector('[data-finder]').addEventListener('focusout', event => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          this.suggestionsDismissed = true;
          this.suggestions.hidden = true;
        }
      }, options);
      this.sortButton.addEventListener('click', () => { this.sortButton.setAttribute('aria-pressed', this.sortButton.getAttribute('aria-pressed') !== 'true' ? 'true' : 'false'); this.updateResults(); }, options);
      this.querySelector('[data-clear]').addEventListener('click', () => { this.input.value = ''; this.updateResults(); this.input.focus(); }, options);
      this.updateResults();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    updateResults() {
      const tokens = this.normalize(this.input.value).split(/\s+/).filter(Boolean);
      const sorted = this.sortButton.getAttribute('aria-pressed') === 'true';
      const cards = [...this.cards];
      if (sorted) cards.sort((a, b) => this.normalize(a.dataset.title).replace(/^the /, '').localeCompare(this.normalize(b.dataset.title).replace(/^the /, ''), 'en'));
      let count = 0;
      cards.forEach(card => { card.hidden = !tokens.every(token => this.normalize(card.dataset.search).includes(token)); if (!card.hidden) count++; this.grid.appendChild(card); });
      this.querySelector('[data-status]').textContent = this.dataset.countTemplate.replace('__COUNT__', String(count));
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.suggestionList.replaceChildren();
      if (tokens.length) {
        cards.filter(card => !card.hidden).forEach(card => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.textContent = card.dataset.title;
          link.href = card.querySelector('a').href;
          item.append(link);
          this.suggestionList.append(item);
        });
      }
      this.querySelector('[data-suggestions-empty]').hidden = count !== 0;
      this.suggestions.hidden = !tokens.length || this.suggestionsDismissed;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
